import * as $ from 'jquery';

//Moves legend to the other side on hover (or click for touch screens)
$.fn.legendSwitch = function () {
    $(this).on('mouseover click', '.legend', function () {
        $(this)
            .children()
            .each(function () {
                var left = $(this).css('left');
                var right = $(this).css('right');
                $(this).css('left', right);
                $(this).css('right', left);
            });
    });
};

//Hides legend on hover
$.fn.legendSlide = function () {
    var cssDefaults = {
        position: 'absolute',
        top: 0,
        right: 0,
        width: '100%',
        height: '100%',
    };
    var cssOptions = {
        position: 'absolute',
        top: $(this).find('.legend > ').first().css('top'),
        right: $(this).find('.legend > ').first().css('right'),
        width: $(this).find('.legend > ').first().css('width'),
        height: $(this).find('.legend > ').first().css('height'),
    };

    //Replace original legend elements css and wrap with a new div
    $(this).find('.legend > ').css(cssDefaults).wrapAll('<div />');
    $(this).find('.legend > ').css(cssOptions);

    $(this).on('mouseover', function () {
        $(this).find('.legend > ').stop(true).slideUp(600);
    });
    $(this).on('mouseleave', function () {
        $(this).find('.legend > ').stop(true).slideDown(600);
    });
};
